import { Col, Image, Row } from 'react-bootstrap';
import { formatMoneyShorthand } from 'utils/formatMoney';
import DefaultAvatar from 'components/global/DefaultAvatar';
import { useDrag } from 'react-dnd';
import FounderPiplineItemContextMenu from 'components/views/FounderPipeline/_components/FounderPiplineItemContextMenu';
import { $view } from 'signals/global.signals';

const FounderPipelineGridItem = ({ pipelineItem }) => {
  // Access the signal value to create a subscription
  const { isDragDisabled } = $view.value;

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: 'investor',
      options: {
        dropEffect: 'move',
      },
      item: { pipelineItem },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [pipelineItem],
  );

  return (
    <div
      ref={isDragDisabled ? null : drag}
      className="py-24 position-relative bg-gray-800 border border-gray-700 rounded px-8"
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: isDragDisabled ? 'default' : 'move',
      }}
    >
      <div className="position-absolute top-0 end-0 pe-8">
        <div><small className="text-gray-700">#{pipelineItem?.dealId}: {pipelineItem?.deal?.name}</small></div>
      </div>
      <Row className="align-items-center">
        <Col sm={2}>
          <div
            className="d-flex justify-content-center rounded-circle flex-shrink-0 profileSettingsAvatar mb-md-0"
            style={{ width: '40px', height: '40px' }}
          >
            {pipelineItem?.organization?.logoImage
              ? <Image src={pipelineItem?.organization?.logoImage} style={{ objectFit: 'cover' }} />
              : (
                <DefaultAvatar
                  name={pipelineItem?.organization?.name}
                  image={pipelineItem?.organization?.logoImage}
                  size="md"
                />
              )}
          </div>
        </Col>
        <Col className="ps-24">
          <div><small className="text-info fw-bold">{pipelineItem?.organization?.name}</small></div>
          <div><small>{formatMoneyShorthand(pipelineItem.amountInvested || 0)} of {formatMoneyShorthand(pipelineItem.previouslyCommitted || 0)} invested</small></div>
        </Col>
      </Row>
      <div className="position-absolute bottom-0 end-0 d-flex align-items-center">
        <FounderPiplineItemContextMenu pipelineItem={pipelineItem} />
      </div>
    </div>
  );
};

export default FounderPipelineGridItem;
